module.exports = __webpack_public_path__ + "img/plan_c2.8577c4b4.webp";